<template>
    <div class="z-0 flex">
        <div class="my-auto flex">
            <img
                class="h-5 w-5 rounded-full bg-gray-200"
                :href="data.logo"
            />
        </div>
        <div class="ml-2 flex flex-col">
            <span class="text-sm font-medium capitalize text-gray-700">{{ data.name }}</span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        required: true,
    },
});
</script>
